import * as React from "react";
import { Text, TextProps } from "../text";
import styled from "styled-components";

const StyledText = styled(Text)<TextProps>`
    margin-bottom: 16px;
`;

type GroupProps = {
    label: string;
    children: React.ReactNode;
};

/**
 *
 * Provides a simple container that shows a label properly styled.
 *
 * Does NOT provide layout (use `<Layout />` component inside)
 *
 * scenarios:
 * - estimated margin calc in job order
 */
export const Group = (props: GroupProps) => {
    const { label, children, ...passthrough } = props;
    return (
        <div {...passthrough}>
            <StyledText variant="h4">{label}</StyledText>
            {children}
        </div>
    );
};
